module.exports = __webpack_public_path__ + "img/blog-list.570fb125.png";